
import HomePage from '../pages/home.vue';
import NotFoundPage from '../pages/404.vue';

// Auth
import Login from '../pages/auth/login.vue';
import Logout from '../pages/auth/logout.vue';
import ForgotPassword from '../pages/auth/forgot-password.vue';
import ResetPassword from '../pages/auth/reset-password.vue';

import TrainingenPage from '../pages/trainingen.vue';
import TrainingSessionIndex from "../pages/training-sessions/_training_session_id/TrainingSessionId.vue";
import ActivityIndex from "../pages/training-sessions/_training_session_id/activities/_activity_id/ActivityId.vue";
import CalendarIndex from "../pages/account/calendar.vue";
import ReserveringenIndex from "../pages/account/reserveringen.vue";
import PaymentsIndex from "../pages/account/payments.vue";
import AbonnementIndex from "../pages/account/abonnement.vue";
import NotificatiesIndex from "../pages/account/notificaties.vue";
import PaymentSuccess from "../pages/account/payment-single/success.vue";
import AdminUsers from "../pages/admin/users.vue";
import AdminGymsUsersInGym from "../pages/admin/UsersInGym.vue";
import AdminNews from "../pages/admin/news.vue";
import AdminBookingStages from "../pages/admin/booking-stages.vue";
import AdminBroadcasts from "../pages/admin/broadcasts.vue";
import AdminBroadcastComposer from "../pages/admin/broadcasts/BroadcastComposerPage.vue";
// One component serves both composer routes — create and edit are the same
// screen in two modes, so they can never render together.
import AdminNewsComposer from "../pages/admin/news/NewsComposerPage.vue";
import UserDetails from "../pages/users/_user_id/UserId.vue";
import VideosTechniekTraining from "../pages/videos/techniek-training.vue";
import VideosEilandInstructies from "../pages/videos/eiland-instructies.vue";
import VideosWorkouts from "../pages/videos/workouts.vue";


import Test1 from "../pages/tests/test1.vue";
import Test2 from "../pages/tests/test2.vue";
import Test3 from "../pages/tests/test3.vue";

// Route guards — UX only. The API middleware is the real authorization
// boundary; see the header of ./guards.js.
import { requireAdmin, requireSuperAdmin } from './guards';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/trainingen',
    component: TrainingenPage,
  },
  {
    path: '/training-sessions/:training_session_id/',
    component: TrainingSessionIndex,
  },
  {
    path: '/training-sessions/:training_session_id/activities/:activity_id',
    component: ActivityIndex,
  },
  {
    path: '/account/calendar',
    component: CalendarIndex,
  },
  {
    path: '/account/reserveringen',
    component: ReserveringenIndex,
  },
  {
    path: '/account/payments',
    component: PaymentsIndex,
  },
  // The member's own subscriptions and payments (40-09). NOT the same screen as
  // /account/payments above, which is the till -- and the two are easy to
  // conflate, because the deep-link key named `abonnement` points at the TILL
  // while the key named `betalingen` points HERE. Both directions are pinned by
  // tests/js/push-taxonomy.test.js.
  {
    path: '/account/abonnement',
    component: AbonnementIndex,
  },
  {
    path: '/account/notificaties',
    component: NotificatiesIndex,
  },
  {
    path: '/account/payment-single/success',
    component: PaymentSuccess,
  },
  {
    path: '/admin/users',
    component: AdminUsers,
    beforeEnter: requireAdmin,
  },
  {
    path: '/admin/gyms/:gym_id/current-users',
    component: AdminGymsUsersInGym,
    beforeEnter: requireAdmin,
  },
  {
    path: '/admin/news',
    component: AdminNews,
    beforeEnter: requireSuperAdmin,
  },
  // Must stay ABOVE /admin/news/:news_id, or the literal `new` is captured as an
  // id and the composer opens in edit mode for an item that does not exist.
  // Same hazard the API's own routes/api.php notes for users.impersonate.stop.
  {
    path: '/admin/news/new',
    component: AdminNewsComposer,
    beforeEnter: requireSuperAdmin,
  },
  {
    path: '/admin/news/:news_id',
    component: AdminNewsComposer,
    beforeEnter: requireSuperAdmin,
  },
  // BOOK-07. `requireSuperAdmin` is STRICT `=== true`, never `requireAdmin`,
  // which is truthy on purpose because `is_admin` arrives as an integer -- it
  // would admit all 13 plain admins to a screen whose every request the API's
  // own `super_admin` middleware answers 403 to.
  {
    path: '/admin/booking-stages',
    component: AdminBookingStages,
    beforeEnter: requireSuperAdmin,
  },
  // B1 / D-44-13. The panel row and this guard are the two UX layers; the API's
  // own `super_admin` middleware is the third and the only real one.
  {
    path: '/admin/broadcasts',
    component: AdminBroadcasts,
    beforeEnter: requireSuperAdmin,
  },
  // B3 / 44-09. Registered TOGETHER WITH the component it imports, which is why
  // 44-08 left it out and pinned the absence with a test rather than leaving a
  // route pointing at a file that did not exist.
  //
  // MUST STAY ABOVE any `/admin/broadcasts/:id` sibling, for the same reason
  // /admin/news/new does: Framework7 matches in declaration order, so a
  // parameter route above this one would capture the literal `new` as an id.
  // There is no such sibling today — a sent broadcast is neither editable nor
  // deletable — so the hazard does not bite yet. The note is here because the
  // day it does, this comment is what a reader finds.
  {
    path: '/admin/broadcasts/new',
    component: AdminBroadcastComposer,
    beforeEnter: requireSuperAdmin,
  },
  {
    path: '/users/:user_id',
    component: UserDetails,
  },
  {
    path: '/videos/techniek-training',
    component: VideosTechniekTraining,
  },
  {
    path: '/videos/eiland-instructies',
    component: VideosEilandInstructies,
  },
  {
    path: '/videos/workouts',
    component: VideosWorkouts,
  },

  {
    path: '/auth/login',
    component: Login,
  },
  {
    path: '/auth/logout',
    component: Logout,
  },
  {
    path: '/auth/forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/auth/reset-password',
    component: ResetPassword,
  },
  // {
  //   path: '/tests/two',
  //   component: Test2,
  // },
  // {
  //   path: '/tests/three',
  //   component: Test3,
  // },

  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
